<div class="mask" *ngIf="isMaskVisible"></div>
